<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="flex max-w-[540px] justify-center px-4">
      <div
        class="flex flex-col items-start gap-5 rounded bg-white p-8 text-left"
      >
        <div>
          <h3 class="mb-4 text-base font-medium text-neutral-boldest">
            File Insurance Information
          </h3>
          <p class="text-left text-sm font-normal text-neutral-subtle-bold">
            To file your insurance information, please provide the name of your
            insurance agency and their contact information so that we can go
            request your Certificate of Insurance (COI).
          </p>
        </div>
        <div class="w-full text-left">
          <label class="text-xs font-semibold text-neutral-subtle"
            >Agency name</label
          >
          <form-field
            :value="agency.name"
            placeholder="Enter agency name"
            :minimal-style="true"
            :custom-padding="true"
            :remove-y-margin="true"
            :on-input="onInput"
            name="name"
          />
        </div>
        <div class="w-full text-left">
          <label class="text-xs font-semibold text-neutral-subtle"
            >Phone number</label
          >
          <form-field
            :value="agency.phoneNumber"
            placeholder="Enter phone number"
            :minimal-style="true"
            :custom-padding="true"
            :remove-y-margin="true"
            :on-input="onInput"
            type="tel"
            name="phoneNumber"
          />
        </div>

        <div class="w-full text-left">
          <label class="text-xs font-semibold text-neutral-subtle">Email</label>
          <form-field
            :value="agency.email"
            placeholder="Enter email"
            :minimal-style="true"
            :custom-padding="true"
            :remove-y-margin="true"
            :on-input="onInput"
            name="email"
            :error="emailError"
          />
        </div>
        <div
          :class="[
            'mt-4 flex w-full gap-3',
            isMobile
              ? 'flex-col-reverse'
              : 'flex-row items-center justify-center',
          ]"
        >
          <button
            class="h-10 w-full rounded-md bg-steel-40 px-3 text-sm font-medium text-neutral-subtle-bold hover:bg-hovered-gray active:bg-pressed-gray"
            @click="$emit('close')"
          >
            Not Now
          </button>

          <button
            class="h-10 w-full rounded-md bg-neutral-subtle-yellow px-3 text-sm font-medium text-neutral-boldest hover:bg-neutral-subtle-yellow-bold active:bg-neutral-subtle-yellow-boldest disabled:cursor-not-allowed disabled:border-light-gray disabled:bg-light-gray disabled:text-pressed-gray"
            :disabled="errorsExist"
            :isLoading="isLoading"
            @click="submitRequest"
          >
            Submit Request
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import FormField from '@/components/FormField.vue';
import Modal from '@/components/modals/Modal.vue';
import WordTools from '@/mixins/wordTools';
import { isEmail } from '@/common/validators';
import { formatPhone } from '@/common/validators';

export default {
  name: 'UpdateInsuranceModal',
  components: {
    Modal,
    FormField,
  },
  mixins: [WordTools],
  props: {
    visible: Boolean,
    type: String,
  },
  emits: ['close', 'submit'],
  data() {
    return {
      agency: {
        name: '',
        phoneNumber: '',
        email: '',
      },
      errors: {
        name: true,
        phoneNumber: true,
        email: true,
      },
      emailError: '',
      phoneError: '',
      isLoading: false,
    };
  },
  computed: {
    errorsExist() {
      return (
        Object.values(this.errors).some((el) => el) ||
        !!this.emailError ||
        !!this.phoneError
      );
    },
  },
  methods: {
    isSameEmailAsTheCurrentUser(email) {
      if (this.$store.state.users.currentUser?.email == email) {
        this.emailError =
          'Your certificate must be provided by an insurance agency';
        return true;
      }
      this.emailError = '';
      return false;
    },
    isSamePhoneAsTheCurrentUser() {
      const currentUserPhone = this.$store.state.users.currentUser?.phone_e164;
      // Only enter this option if the user has not configured a telephone - Only for cases of large carriers
      if (!currentUserPhone) return false;

      const find = '-';
      const re = new RegExp(find, 'g');

      const phoneAgency = this.agency.phoneNumber.replace(re, '');
      const phoneWithoutCountryCode = currentUserPhone.substr(
        currentUserPhone.length - 10
      );
      if (phoneWithoutCountryCode == phoneAgency) {
        this.phoneError =
          'Your certificate must be provided by an insurance agency';
        return true;
      }
      this.phoneError = '';
      return false;
    },
    onInput(e) {
      const { name, value } = e.target;

      let val = value;
      if (name === 'name') {
        this.errors.name = !value.length;
      } else if (name === 'email') {
        this.errors.email = !isEmail(value) && !!value.length;
        if (isEmail(value)) {
          this.isSameEmailAsTheCurrentUser(value);
        }
      } else if (name === 'phoneNumber') {
        const formattedValue = formatPhone(value);
        val = formattedValue;
        this.errors.phoneNumber = val.length !== 12;

        if (val.length === 12) {
          this.isSamePhoneAsTheCurrentUser();
        }
      }

      this.agency[name] = val;
    },
    submitRequest() {
      this.$emit('submit', this.agency);
      this.isLoading = true;
    },
  },
};
</script>

<style scoped></style>
